import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ConfigInterface } from '@vendasta/sales-orders';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TermsOfServiceInterface } from '@vendasta/sales-orders';
import { TranslateService } from '@ngx-translate/core';

interface TermsOfService extends TermsOfServiceInterface {
  innerHtml?: boolean;
}

export interface Agreement {
  term: string;
  agreed: boolean;
}

@Component({
  selector: 'orders-terms',
  templateUrl: './order-terms.component.html',
  styleUrls: ['./order-terms.component.scss'],
  standalone: false,
})
export class OrderTermsComponent implements OnInit {
  @Input() orderConfig: ConfigInterface;
  @Input() partnerName: string;
  @Input() parentForm: UntypedFormGroup;

  @ViewChildren('term') termsDisplayed: QueryList<any>;

  formArray: UntypedFormArray;
  terms: TermsOfService[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.setToS();
  }

  // sets the ToS for the user to accept
  private setToS(): void {
    const basicToSText = this.translateService.instant('LIB_ORDERS.ORDER_CONFIRMATION.CONFIRMATION', {
      partner_name: this.partnerName,
    });
    const urlTosText = this.translateService.instant('LIB_ORDERS.ORDER_CONFIRMATION.TERMS_OF_SERVICE_CONFIRMATION', {
      terms_of_service_url: this.orderConfig.termsOfServiceUrl,
    });
    const options = this.orderConfig.customerTermsOfServiceOptions
      ? this.orderConfig.customerTermsOfServiceOptions
      : { hideDefaultTermsOfService: false, termsOfService: [] };
    this.formArray = this.fb.array([]);
    this.parentForm.addControl('formArray', this.formArray);

    // default ToS is displayed first, unless config specifies otherwise
    if (!options.hideDefaultTermsOfService) {
      this.formArray.push(new UntypedFormControl(false, Validators.required));
      if (this.orderConfig.termsOfServiceUrl) {
        this.terms.push({ text: urlTosText, required: true, innerHtml: true });
      } else {
        this.terms.push({ text: basicToSText, required: true });
      }
    }

    (options.termsOfService || []).map((tos) => {
      this.terms.push(tos);
      if (tos.required) {
        this.formArray.push(new UntypedFormControl(false, Validators.required));
      } else {
        this.formArray.push(new UntypedFormControl(false));
      }
    });
  }

  getAgreements(): Agreement[] {
    return this.termsDisplayed.map((t, i) => ({
      term: t.nativeElement.innerHTML.trim(),
      agreed: this.formArray.controls[i].value,
    }));
  }
}
